import styled from '@emotion/styled'
import { colorGrayscaleDark2, gold } from '@lib/colors'

export const DocumentWrapper = styled.div({
  a: {
    color: gold,
    display: 'inline-block',
    position: 'relative',
    textDecoration: 'none',
    '&:after': {
      borderBottom: `solid 1px ${gold}`,
      content: '""',
      display: 'block',
      transition: 'width .35s ease-in',
      width: 0,
    },
    '&:hover:after': {
      width: '100%',
    },
  },
  h2: {
    fontFamily: '"Inter", sans-serif',
    fontSize: '1.25rem',
    marginTop: '2rem',
    textTransform: 'none',
  },
  h3: {
    fontFamily: '"Inter", sans-serif',
    fontSize: '1.15rem',
    marginTop: '1.5rem',
    textTransform: 'none',
  },
  h4: {
    fontFamily: '"Inter", sans-serif',
    fontSize: '1.05rem',
    marginTop: '2rem',
    textTransform: 'none',
  },
  li: {
    display: 'block',
    listStyle: 'none',
    '&:before': {
      color: gold,
      content: '"•"',
      display: 'inline-block',
      fontWeight: 'bold',
      marginLeft: '-1rem',
      position: 'absolute',
      width: '1rem',
    },
    '&:not(:first-of-type)': {
      marginTop: '1.5rem',
    },
  },
})

export const LastUpdated = styled.p({
  color: colorGrayscaleDark2,
  fontSize: '.75rem',
  marginBottom: '3rem',
  textAlign: 'center',
  width: '100%',
})

export const Title = styled.h1({
  fontSize: '3.375rem',
  textAlign: 'center',
  width: '100%',
})
